export default {
  init() {

  },
  finalize() {
    $('.woocommerce-shipping-fields > .shipping_address').hide();
    $('.woocommerce-shipping-fields input[name="ship_to_different_address"]').on('change', function() {
      if ($(this).is(':checked')) {
        $('.woocommerce-shipping-fields > .shipping_address').show();
      } else {
        $('.woocommerce-shipping-fields > .shipping_address').hide();
      }
    });

    // Change order notes to attendee names for events only.
    if (new URLSearchParams(window.location.search).get('event')) {
      const attendeeNames = $('#translated-attendee-names').data('attendee-names');
      $('label[for="order_comments"]').html(attendeeNames);
      $('#order_comments').attr('placeholder', '');
    }

    // Set date, time if applicable
    setInterval(() => {
      const $variationBookingDate = $('dt.variation-BookingDate');
      if ($variationBookingDate.length > 0) {
        $variationBookingDate.html($('#translated-date-time').data('date'));
      }
      
      // Cy
      const $variationBookingDateCy = $('dt.variation-Dyddiadysesiwn');
      if ($variationBookingDateCy.length > 0) {
        $variationBookingDateCy.html($('#translated-date-time').data('date'));
      }
      
      const $variationBookingTime = $('dt.variation-BookingTime');
      if ($variationBookingTime.length > 0) {
        $variationBookingTime.html($('#translated-date-time').data('time'));
      }

      // Cy date itself
      if ($('html').attr('lang') == 'cy-GB') {
        const $variationBookingDateText = $('dd.variation-Dyddiadysesiwn');
        if ($variationBookingDateText.length > 0) {
          $variationBookingDateText.each(function() {
            var text = $(this).find('p').html();

            // Just replace the month
            const months = {
              January: 'Ionawr',
              February: 'Chwefror',
              March: 'Mawrth',
              April: 'Ebrill',
              May: 'Mai',
              June: 'Mehefin',
              July: 'Gorffennaf',
              August: 'Awst',
              September: 'Medi',
              October: 'Hydref',
              November: 'Tachwedd',
              December: 'Rhagfyr',
            };

            Object.keys(months).forEach((month, index) => {
              text = text.replaceAll(month, months[month]);
            });

            $(this).find('p').html(text);
          });
        }
      }
    }, 500);

    // If there is only one shipping method we don't need radio
    let shippingMethodsInterval = setInterval(() => {
      const $shippingMethods = $('#shipping_method.woocommerce-shipping-methods');

      if ($shippingMethods.length > 0) {
        if ($shippingMethods.find('li').length > 0) {
          if ($shippingMethods.find('li').length == 1) {
            $shippingMethods.addClass('only-one');
            clearInterval(shippingMethodsInterval);
          }
        }
      }
    }, 500);

    // If shipping is free we can hide it and subtotal.
    if ($('.cart-subtotal bdi').html() == $('.order-total bdi').html()) {
      $('.order-sidebar').addClass('hide-shipping');
      $('.order-sidebar').addClass('hide-subtotal');
    }

    // When clicking 'Pay' trigger the 'Skip to payment' button in the donations dialog
    // if there is already a donation in the cart to avoid confusion.
    if ($('.checkout-wrap').data('has-donation')) {
      $('body').on('click', function(e) {
        if ($(e.target).attr('id') == 'place_order') {
          e.preventDefault();
          e.stopPropagation();

          $('button#wc-donation-round-f-submit-skip-donation').trigger('click');
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateCheckout.js